import {RouteView, PageView} from '../layouts'

export const skin = {
  path: '/skin',
  redirect: '/skin/skinList',
  meta: { title: '客户端皮肤补丁', icon: 'skin', isMenuShow:true, permission: 'skin'},
  component:PageView,
  children: [
    {
      path: '/skin/skinList',
      name: 'skinList',
      component: () => import('../views/skinPatch/skinList.vue'),
      meta: {title: '皮肤包列表', icon: 'skin', isMenuShow: true, permission: 'skin:list'},
    },
    {
      path: '/skin/skinAdd',
      name: 'skinAdd',
      component: () => import('../views/skinPatch/skinAdd.vue'),
      meta: {title: '上传皮肤补丁包', icon: 'skin', isMenuShow: false, permission: 'skin:list:add'},
    },
    {
      path: '/skin/skinUpdate',
      name: 'skinUpdate',
      component: () => import('../views/skinPatch/skinAdd.vue'),
      meta: {title: '修改皮肤补丁包', icon: 'skin', isMenuShow: false, permission: 'skin:list:alter'},
    }
  ]
}
